import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root'
})
export class PusherService {

  private pusher: Pusher;

  private channel: any;

  constructor() { 

    this.pusher = new Pusher(
      environment.pusherKey,
      {
        cluster: environment.pusherCluster,
      }
    )

    // this.channel = this.pusher.subscribe(environment.pusherChannel);
  }

  listen(channelName: string, eventName: string, callback: (data: any) => void) {
    let channel = this.pusher.subscribe(channelName);
    channel.bind(eventName, callback);
  }

  unsubscribe(eventName: string) {
    this.channel.unbind(eventName);
  }

  disconnect() {
    this.pusher.disconnect();
  }
}
